var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isSavvyEnabled
    ? _c(
        "NuxStep",
        {
          key: _vm.currentStepContent.title,
          class: [_vm.currentStepContent.stepClass],
          attrs: {
            title: _vm.currentStepContent.title,
            text: _vm.currentStepContent.text,
            "reverse-text-and-content":
              _vm.currentStepContent.stepType === "media",
            "continue-button-text": "Continue",
            "button-disabled": _vm.disableContinueButton,
            loading: _vm.formSubmitted,
            "current-step": 1,
            "show-back-link": false,
            "steps-count": _vm.stepsCount,
            "transition-name": "none",
            "test-id-prefix": "user_welcome_step"
          },
          on: { next: _vm.next }
        },
        [
          _vm.currentStepContent.stepType === "media"
            ? _c("NuxStepMedia", {
                attrs: {
                  "image-src": _vm.currentStepContent.imageSrc,
                  "video-poster": _vm.currentStepContent.videoPoster,
                  "video-src": _vm.currentStepContent.videoSrc
                }
              })
            : _c("NuxStepSurvey", {
                attrs: {
                  choices: _vm.choices,
                  "current-selection": _vm.choice
                },
                on: {
                  chosen: function($event) {
                    return _vm.selectAnswer($event)
                  }
                }
              })
        ],
        1
      )
    : _c("SavvyFlow", {
        attrs: {
          "flow-id": _vm.savvyId,
          "flow-data": _vm.embed,
          "custom-actions": [{ name: "saveAnswer", action: _vm.saveAnswer }]
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }